import karcothTheKing from "../img/karcothTheKing.png";
import timeTraveler from "../img/timeTraveler.png";
import burningHorse from "../img/burningHorse.png";
import firandilTheBloody from "../img/firandilTheBloody.png";
import lightOfAzhura from "../img/lightOfAzhura.png";
import militaryHornist from "../img/militaryHornist.png";
import berserker from "../img/berserker.png";
import strongFarmer from "../img/strongFarmer.png";
import caplanOfMiridith from "../img/caplanOfMiridith.png";
import castleDefender from "../img/castleDefender.png";
import hound from "../img/hound.png";
import treeOfVitality from "../img/treeOfVitality.png";
import weakFarmer from "../img/weakFarmer2.jpeg";
import azhura from "../img/azhura.png";
import princessLaurith from "../img/princessLaurith.png";
import archmageValorian from "../img/archmageValorian.png";
import cirilTheMighty from "../img/cirilTheMighty.png";
import kingsDefender from "../img/kingsDefender.png";

export const cards = [
  {
    name: "Weak Farmer",
    defaultAttack: 2,
    attack: 2,
    cost: 1,
    defaultTurns: 3,
    turns: 3,
    ability: "",
    img: weakFarmer,
    id: 1,
  },
  {
    name: "Weak Farmer",
    defaultAttack: 2,
    attack: 2,
    cost: 1,
    defaultTurns: 3,
    turns: 3,
    ability: "",
    img: weakFarmer,
    id: 2,
  },
  {
    name: "Tree of Vitality",
    defaultHealing: 4,
    healing: 4,
    cost: 2,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: treeOfVitality,
    id: 3,
  },
  {
    name: "Tree of Vitality",
    defaultHealing: 4,
    healing: 4,
    cost: 2,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: treeOfVitality,
    id: 4,
  },
  {
    name: "Hound",
    defaultAttack: 3,
    attack: 3,
    cost: 1,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: hound,
    id: 5,
  },
  {
    name: "Hound",
    defaultAttack: 3,
    attack: 3,
    cost: 1,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: hound,
    id: 6,
  },
  {
    name: "Castle Guardian",
    defaultAttack: 4,
    attack: 4,
    cost: 2,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: castleDefender,
    id: 7,
  },
  {
    name: "Castle Guardian",
    defaultAttack: 4,
    attack: 4,
    cost: 2,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: castleDefender,
    id: 8,
  },
  {
    name: "Caplan of Miridith",
    defaultHealing: 5,
    healing: 5,
    cost: 3,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: caplanOfMiridith,
    id: 9,
  },
  {
    name: "Caplan of Miridith",
    defaultHealing: 5,
    healing: 5,
    cost: 3,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: caplanOfMiridith,
    id: 10,
  },
  {
    name: "Strong farmer",
    defaultAttack: 4,
    attack: 4,
    cost: 3,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: strongFarmer,
    id: 11,
  },
  {
    name: "Strong farmer",
    defaultAttack: 4,
    attack: 4,
    cost: 3,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: strongFarmer,
    id: 12,
  },
  {
    name: "Berserker",
    defaultAttack: 7,
    attack: 7,
    cost: 4,
    defaultTurns: 1,
    turns: 1,
    ability: "",
    img: berserker,
    id: 13,
  },
  {
    name: "Berserker",
    defaultAttack: 7,
    attack: 7,
    cost: 4,
    defaultTurns: 1,
    turns: 1,
    ability: "Rage",
    img: berserker,
    id: 14,
  },
  {
    name: "King's Defender",
    defaultAttack: 4,
    attack: 4,
    cost: 4,
    defaultTurns: 3,
    turns: 3,
    ability: "",
    img: kingsDefender,
    id: 15,
  },
  {
    name: "King's Defender",
    defaultAttack: 4,
    attack: 4,
    cost: 4,
    defaultTurns: 3,
    turns: 3,
    ability: "",
    img: kingsDefender,
    id: 16,
  },
  {
    name: "Military Hornist",
    defaultAttack: 3,
    attack: 3,
    cost: 4,
    defaultTurns: 3,
    turns: 3,
    ability: "Rage",
    img: militaryHornist,
    id: 17,
  },
  {
    name: "Military Hornist",
    defaultAttack: 3,
    attack: 3,
    cost: 4,
    defaultTurns: 3,
    turns: 3,
    ability: "Rage",
    img: militaryHornist,
    id: 18,
  },
  {
    name: "Light of Azhura",
    defaultHealing: 5,
    healing: 5,
    cost: 5,
    defaultTurns: 3,
    turns: 3,
    ability: "Blessing",
    img: lightOfAzhura,
    id: 19,
  },
  {
    name: "Light of Azhura",
    defaultHealing: 5,
    healing: 5,
    cost: 5,
    defaultTurns: 3,
    turns: 3,
    ability: "Blessing",
    img: lightOfAzhura,
    id: 20,
  },
  {
    name: "Firandil the Bloody",
    defaultAttack: 6,
    attack: 6,
    cost: 5,
    defaultTurns: 3,
    turns: 3,
    ability: "Rage",
    img: firandilTheBloody,
    id: 21,
  },
  {
    name: "Burning Horse",
    defaultAttack: 7,
    attack: 7,
    cost: 5,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: burningHorse,
    id: 22,
  },
  {
    name: "Burning Horse",
    defaultAttack: 7,
    attack: 7,
    cost: 5,
    defaultTurns: 2,
    turns: 2,
    ability: "",
    img: burningHorse,
    id: 23,
  },
  {
    name: "Time traveler",
    defaultAttack: 3,
    attack: 3,
    cost: 5,
    defaultTurns: 2,
    turns: 2,
    ability: "Hourglass",
    img: timeTraveler,
    id: 24,
  },
  {
    name: "Time traveler",
    defaultAttack: 3,
    attack: 3,
    cost: 5,
    defaultTurns: 2,
    turns: 2,
    ability: "Hourglass",
    img: timeTraveler,
    id: 25,
  },
  {
    name: "Ciril the Mighty",
    defaultAttack: 7,
    attack: 7,
    cost: 7,
    defaultTurns: 4,
    turns: 4,
    ability: "",
    img: cirilTheMighty,
    id: 26,
  },
  {
    name: "Archmage Valorian",
    defaultAttack: 6,
    attack: 6,
    cost: 7,
    defaultTurns: 5,
    turns: 5,
    ability: "",
    img: archmageValorian,
    id: 27,
  },
  {
    name: "Princess Laurith",
    defaultHealing: 7,
    healing: 7,
    cost: 7,
    defaultTurns: 3,
    turns: 3,
    ability: "Blessing",
    img: princessLaurith,
    id: 28,
  },
  {
    name: "Karcoth The King",
    defaultAttack: 8,
    attack: 8,
    cost: 8,
    defaultTurns: 4,
    turns: 4,
    ability: "",
    img: karcothTheKing,
    id: 29,
  },
  {
    name: "Azhura",
    defaultAttack: 8,
    attack: 8,
    cost: 9,
    defaultTurns: 3,
    turns: 3,
    ability: "Hourglass",
    img: azhura,
    id: 30,
  },
];
